<template>
  <v-container>
    <v-fab-transition>
      <v-btn
        class="mt-12"
        :loading="loading"
        color="primary"
        dark
        absolute
        top
        right
        fab
        @click="save"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-fab-transition>
    <ProfilEditForm :save="save" ref="EditForm" :newUser="newUser" />
  </v-container>
</template>

<script>
//import * as firebase from 'firebase/app';
import { db } from "../main";
import ProfilEditForm from "@/components/ProfilEditForm.vue";

export default {
  components: {
    ProfilEditForm
  },

  methods: {
    async save() {
      this.loading = true;
      //this.$refs.form.validate();
      // remove spaces from number: str = str.replace(/\s/g,'');
      if (this.$refs.EditForm.$refs.form.validate()) {
        if (this.newUser.number) {
          this.newUser.number = parseInt(
            this.newUser.number.replace(/\s/g, "")
          );
        }

        //save to DB
        console.log("Saving...", this.newUser);

        try {
          const writeResult = await db.collection("profiles").add(this.newUser);
          console.log("result:", writeResult);
          const id = writeResult.id;
          this.$store.dispatch("snackbar", {
            showing: true,
            text: "Profilen er gemt",
            timeout: 4000,
            color: "success"
          });
          this.loading = false;
          this.$router.push({ name: "profil", params: { id } }); // -> /user/123
        } catch (e) {
          console.log("Noget gik galt...", e);

          this.loading = false;
          this.$store.dispatch("snackbar", {
            showing: true,
            text: "Tjek dine inputs",
            timeout: 2000,
            color: "error"
          });
        }
      } else {
        this.loading = false;
        this.$store.dispatch("snackbar", {
          showing: true,
          text: "Tjek dine inputs",
          timeout: 2000,
          color: "error"
        });
      }
    }
  },

  data() {
    return {
      loading: false,
      valid: false,
      newUser: {
        active: true,
        address: {}
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
